var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"content has-text-grey has-text-centered"},[_c('p',[_c('b-icon',{attrs:{"icon":"frown","size":"is-large"}})],1),_c('p',[_vm._v(_vm._s(_vm.$t("common.tableEmptyMessage")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }